/**
 * Pure helpers for Support Mode — Impersonate Support reference UX.
 */

export type SupportRefMode =
  | "existing-ticket"
  | "ad-hoc-created"
  | "maintenance";

export function filterOpenTicketsForSearch<
  T extends {
    ticketId?: string | null;
    summary?: string | null;
    clientCaseLabel?: string | null;
    clientCaseNumber?: number | null;
    status?: string | null;
    brandName?: string | null;
  },
>(tickets: T[], search: string, isOpen: (status?: string | null) => boolean): T[] {
  const open = tickets.filter((t) => isOpen(t.status));
  const q = String(search || "").trim().toLowerCase();
  if (!q) return open;
  return open.filter((t) => {
    const hay = [
      t.ticketId,
      t.summary,
      t.clientCaseLabel,
      t.clientCaseNumber != null ? String(t.clientCaseNumber) : "",
      t.status,
      t.brandName,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
    return hay.includes(q);
  });
}

export function canShowMaintenanceAccess(canSuperAdminLifecycle: boolean): boolean {
  return Boolean(canSuperAdminLifecycle);
}
